import { SectionFourDocTypeEnum } from "../../../../../journals-section-fourth/ui/journal-section-form/model/types/documents-four-enum";

export type ApprovalStatus =
  | "NEW"
  | "RECREATED"
  | "REJECTED"
  | "SIGNED"
  | "SIGNING"
  | "APPROVAL"
  | "APPROVED";

export const ApprovalStatusTypes = {
  NEW: "NEW",
  RECREATED: "RECREATED",
  REJECTED: "REJECTED",
  SIGNED: "SIGNED",
  SIGNING: "SIGNING",
  APPROVAL: "APPROVAL",
  APPROVED: "APPROVED",
} as const;

export type ApprovalStatusEnum = (typeof ApprovalStatusTypes)[keyof typeof ApprovalStatusTypes];

export const ApprovalStatusLabels: Record<ApprovalStatus, string> = {
  [ApprovalStatusTypes.NEW]: "Новое",
  [ApprovalStatusTypes.RECREATED]: "Обновлено",
  [ApprovalStatusTypes.REJECTED]: "Отклонено",
  [ApprovalStatusTypes.APPROVAL]: "На согласовании",
  [ApprovalStatusTypes.APPROVED]: "Согласовано",
  [ApprovalStatusTypes.SIGNING]: "На подписании",
  [ApprovalStatusTypes.SIGNED]: "Подписано",
};

export const getApprovalStatusLabel = (status: ApprovalStatus): string => {
  return ApprovalStatusLabels[status] || status;
};

export type DocumentType = SectionFourDocTypeEnum | string;

export interface RelatedDocument {
  documentType: DocumentType;
  documentId: string;
  name: string;
  linkToPdf: string;
}

export interface Work {
  workId: string;
  workName: string;
  workDateStart: string;
  workDateEnd: string;
  place: string;
  relatedDocuments: RelatedDocument[];
}

export interface ExecutionAct {
  actId: string;
  number: string;
  actDate: string;
  name: string;
  approvalStatus: ApprovalStatus;
  lastUpdated: string;
  linkToActCard: string;
  linkToPdf: string;
  works: Work[];
}

export interface ExecutionDataResponse {
  pageCount: number;
  pageNumber: number;
  pageSize: number;
  entityList: ExecutionAct[];
}

